export default __webpack_public_path__ + "static/media/vlap-logo.69cb3e8d.svg";